var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPictoQuadrante2Pt(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "33px",
    viewBox: "0 0 38 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Picto Quadrante &gt; 2pt") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PICTOGRAMAS-CATEGORIES",
    transform: "translate(-348.000000, -402.000000)",
    stroke: "#00A9FD",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Picto-Quadrante->-2pt",
    transform: "translate(349.000000, 403.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.4788101,16.6341875 C31.5198228,17.0740462 31.5407848,17.5202929 31.5407848,17.9715587 C31.5407848,20.2315381 31.0873671,22.4052797 30.1458987,24.2933868",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.51401519,24.2912879 C5.00409114,23.268297 4.61538228,22.1613497 4.36566076,21.0023859 C4.15467342,20.0231984 4.04393924,19.0065955 4.04393924,17.9717412 C4.04393924,10.2609817 10.1780658,4.04911834 17.7922937,4.04866205 C22.0849519,4.04866205 25.9073316,6.02300707 28.4255089,9.12756991",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.027281,17.8152811 C21.027281,19.6043744 19.5790785,21.054448 17.7922937,21.054448 C16.0055089,21.054448 14.5573063,19.6043744 14.5573063,17.8152811 C14.5573063,16.0261878 16.0055089,14.5761142 17.7922937,14.5761142 C19.5790785,14.5761142 21.027281,16.0261878 21.027281,17.8152811 Z",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5573519,19.2728834 L10.5135038,21.0542199",
    id: "Stroke-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8434785,12.013481 L21.0273266,16.4225626",
    id: "Stroke-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7485823,26.7229217 L21.8358228,26.7229217",
    id: "Stroke-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7922937,0 C7.96566076,0 9.11392407e-05,7.97631734 9.11392407e-05,17.8151899 C9.11392407e-05,22.9219311 2.14915443,27.5235649 5.58738228,30.7718575 L29.9972051,30.7718575 C33.4354329,27.5235649 35.5844962,22.9219311 35.5844962,17.8151899 C35.5844962,7.97631734 27.6189266,0 17.7922937,0 Z",
    id: "Stroke-13"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoQuadrante2Pt);
export default __webpack_public_path__ + "static/media/PictoQuadrante_2pt.daf5b43a47ef4800a91e57ea21bc4849.svg";
export { ForwardRef as ReactComponent };